import { render, staticRenderFns } from "./PencilSquare.vue?vue&type=template&id=48d977e9&scoped=true&"
import script from "./PencilSquare.js?vue&type=script&lang=js&"
export * from "./PencilSquare.js?vue&type=script&lang=js&"
import style0 from "./PencilSquare.vue?vue&type=style&index=0&id=48d977e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d977e9",
  null
  
)

export default component.exports